"use client";

import type { HTMLAttributes, FC, Ref } from "react";

import type { ClassNameProp } from "../../props";
import type { TableData, ValueType } from "../../types";
import { Card, type CardProps } from "../Card/Card";
import { Table } from "../Table/Table";
import { tableStyle } from "./TableCard.css";
import { CardSubPanel } from "../CardSubPanel/CardSubPanel";
import { Text } from "../Text/Text";

export type TableCardProps = HTMLAttributes<HTMLDivElement> &
  ClassNameProp &
  Pick<CardProps, "border"> & {
    title?: string;
    value?: ValueType;
    type?: "mortgage";
    data: TableData;
    /**
     * Ref forwarded to the root element
     */
    ref?: Ref<HTMLDivElement>;
  };

/**
 * TableCard is a component that displays a table of data.
 */
export const TableCard: FC<TableCardProps> = ({
  type,
  title,
  value,
  data,
  border = "default",
  className,
  ref,
  ...props
}) => (
  <Card ref={ref} className={className} border={border} {...props}>
    {title && value !== undefined && (
      <CardSubPanel
        icon={type === "mortgage" ? "mortgage" : undefined}
        title={title}
        value={value}
      />
    )}
    {title && value === undefined && (
      <Text variant="surfaceSubtitle" color="currentColor50">
        {title}
      </Text>
    )}
    <Table className={tableStyle} data={data} color="currentColor50" />
  </Card>
);
